// extracted by mini-css-extract-plugin
export var absolute = "marketing-button-module--absolute--198a8";
export var blocPrincipal = "marketing-button-module--blocPrincipal--293f4";
export var blocToHover = "marketing-button-module--blocToHover--73719";
export var displayMarketing = "marketing-button-module--displayMarketing--91ad0";
export var h3Text = "marketing-button-module--h3Text--fecbd";
export var hideMarketing = "marketing-button-module--hideMarketing--0a60e";
export var hoveredBloc = "marketing-button-module--hoveredBloc--05126";
export var imgWrapper = "marketing-button-module--imgWrapper--7c7d2";
export var itemContainer = "marketing-button-module--itemContainer--9ce0a";
export var link = "marketing-button-module--link--dd8c9";
export var margin = "marketing-button-module--margin--bcf44";
export var rootContainer = "marketing-button-module--rootContainer--bb057";
export var rootContainerChild = "marketing-button-module--rootContainerChild--4a7dc";
export var subText = "marketing-button-module--subText--6ab0d";
export var text = "marketing-button-module--text--1e6b5";